module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAATklEQVRIiWP8//8/Ay0BE01NZ2BgYPxaodXAwMBQTyPzG0EW0DSMaB5EIAsaaWh+49BPRUPfgtF8QJQFo/lgmFswmg+IsmA0H+AGDAwMAHeHIChHPqjeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/home-menu-button.png
// module id = 514
// module chunks = 0